import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isPhoneNumberValid } from '../app/shared/util/phone-number-util';

export const PhoneValidator = function (control: AbstractControl): ValidationErrors {
  if (control.value && !isPhoneNumberValid(control.value)) {
    return {
      incorrectPhoneNumber: true,
    };
  }

  return {};
};
